module.exports = "https://static.wagwalking.com/_next/static/images/pettedlogo-5e7ea77fb1995808aca27081c8fd94f6.svg";